import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation AvailabilityUpdateMultiMutation (
  $workspace: ID!,
  $data: [AvailabilityUpdateData!]!
) {
  availabilityBulkUpdate (
    workspace: $workspace
    data: $data
  ) {
    id
  }
}`

async function requestAvailabilityUpdateMulti (variables, token) {
  const response = await fetchRequest({ query, variables, token })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('availability-update-multi', errors)
  }
  return data.availabilityBulkUpdate
}

export default requestAvailabilityUpdateMulti
